module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (241).92288c64.jpg";